import { TEAMMEMBER } from "./Actions";
import { api, APIS } from "../config/Config";

export function getTeamMemberAction(researchProgramId) {
  return async function (dispatch) {
    let res;
    try {
      dispatch({ type: TEAMMEMBER.LOADING });
      res = await api(`${APIS.team}${researchProgramId ? '&researchProgramId=' + researchProgramId : ''}`);

      const { success, data } = res.data;

      if (success === "true") {
        dispatch({ type: TEAMMEMBER.SUCCESS, payload: data.data });
      } else {
        dispatch({ type: TEAMMEMBER.ERROR });
      }
    } catch ({ message }) {
      dispatch({ type: TEAMMEMBER.ERROR });
      console.error(message);
      return 0;
    }
  };
}
